"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var twitter = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 1167 1000", fill: "currentColor", width: size || '1em', height: size || '1em' }, props),
        React.createElement("path", { fill: "currentColor", d: "M1048 249v33c0 334-240 719-681 719-135 0-261-42-367-114 19 3 38 4 57 4 112 0 216-41 298-108-105-2-194-75-224-176 15 3 30 5 45 5 22 0 43-3 63-9C130 580 47 478 47 355v-3c32 19 69 30 108 32C91 339 49 261 49 174c0-47 12-90 32-127 118 152 295 253 494 264-4-19-6-38-6-58C569 113 676 0 808 0c69 0 131 31 175 80 54-11 105-32 152-61-18 59-56 108-106 140 49-7 95-20 138-40-32 50-73 95-119 130z" })));
};
twitter.displayName = 'twitter';
exports.default = twitter;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=twitter.js.map